import { HTTPInstanceWithPrefix } from '@/lib/http/http-instance-with-prefix'
import {
  GetDeviceResponse,
  RegisterDevicePayload,
  RegisterDeviceResponse
} from './DevicesAPI.model'

class DevicesAPI {
  static registerDevice(
    payload: RegisterDevicePayload
  ): Promise<RegisterDeviceResponse> {
    return HTTPInstanceWithPrefix.post('/devices/register', payload).then(
      response => response.data
    )
  }

  static getDevices(): Promise<GetDeviceResponse[]> {
    return HTTPInstanceWithPrefix.get('/devices').then(response => response.data)
  }

  static deleteDevice(deviceId: string): Promise<void> {
    return HTTPInstanceWithPrefix.delete(`/devices/${deviceId}`).then(
      response => response.data
    )
  }
}

export default DevicesAPI
